var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loggedIn)?_c('div',{staticClass:"page-container chat-visible",class:{'sidebar-collapsed--chat' : _vm.sidebarStateRight, 'sidebar-collapsed' : _vm.sidebarStateLeft}},[_c('app-left-panel'),_vm._v(" "),_c('app-profile-form')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }